module.exports = __webpack_public_path__ + "img/Khavar_Mianeh.fdf915f4.svg";